import { ApiBulkSession, ApiBulkUploadResultState, ApiBulkUploadStatus, ApiMemberResponseRow } from '@agunity/api-v4';
import { Grid } from '@mui/material';
import { useIntl } from 'react-intl';

import ErrorTable from './ErrorTable';
import { AgColor } from '../../../stories/Styles/AgColor';
import AgTypography from '../../../stories/Styles/AgTypography';
import AgAlert from '../../../components/AgAlert/Alert';
import { useMemo } from 'react';

const Errors = ({ details }: { details: ApiBulkSession }) => {
  const { formatMessage } = useIntl();

  const errors = details?.errors || [];
  const warnings = (details?.warnings || [])?.map((warning) => ({ ...warning, type: 'warning' })) || [];
  const combinedErrors = [...errors, ...warnings] as (ApiMemberResponseRow & { type: 'warning' | 'error' })[];

  const infoStatus = useMemo(() => {
    let results = {
      message: formatMessage({ id: 'BULK_UPLOAD_REQUEST_NO_ERRORS' }),
      type: 'success' as 'error' | 'success' | 'info' | 'customError'
    };

    if (details?.state === ApiBulkUploadStatus.Created) {
      results.type = 'info';
      results.message = formatMessage({ id: 'BULK_UPLOAD_REQUEST_CHECKING_FOR_ISSUES' });
    }

    if (details?.resultState === ApiBulkUploadResultState.FailedValidate) {
      results.type = 'error';
      results.message = formatMessage({ id: 'BULK_UPLOAD_REQUEST_FAILED_TO_VALIDATE' });
    }

    return results;
  }, [details?.resultState, details?.state, formatMessage]);

  return (
    <>
      <Grid item xs={12}>
        <AgTypography
          contentStyle='AP.H5.UPPERCASE.Bold'
          message={formatMessage({ id: 'BULK_UPLOAD_REQUEST_ERRORS' })}
          style={{ color: AgColor.grey6 }}
        />
      </Grid>

      <Grid item xs={12}>
        <AgTypography
          contentStyle='AP.Paragraph.Small.Regular'
          message={formatMessage({ id: 'BULK_UPLOAD_REQUEST_ERRORS_DESC' })}
          style={{ color: AgColor.grey7 }}
        />
      </Grid>

      <Grid item xs={12}>
        {combinedErrors.length > 0
          ? <ErrorTable combinedErrors={combinedErrors} />
          : <AgAlert type={infoStatus.type} message={infoStatus.message} />}
      </Grid>
    </>
  );
};

export default Errors;